import { useState, useContext, useEffect, useRef } from 'react';
import GlobalContext from "../context/GlobalContext.js";

export default function MFACode({ setParentCode, loadingSpinner, setLoadingSpinner }) {
    const { settings } = useContext(GlobalContext);
    const primaryColor = settings?.primary_hex_colour || '#813468';
    const [digits, setDigits] = useState(['', '', '', '', '', '']);
    const inputsRef = useRef([]);

    useEffect(() => {
        inputsRef.current[0]?.focus();
    }, []);

    function updateDigits(newDigits) {
        setDigits(newDigits);
        const code = newDigits.join('');
        if (code.length === 6) {
            setLoadingSpinner(true);
            setParentCode(code);
        }
    }

    function handleChange(e, index) {
        const val = e.target.value.replace(/[^\d]/g, '');
        if (!val) return;
        const newDigits = [...digits];
        newDigits[index] = val.slice(-1);
        updateDigits(newDigits);
        if (index < 5) inputsRef.current[index + 1]?.focus();
    }

    function handleKeyDown(e, index) {
        if (e.key === 'Backspace') {
            e.preventDefault();
            const newDigits = [...digits];
            if (digits[index]) {
                newDigits[index] = '';
                setDigits(newDigits);
            } else if (index > 0) {
                newDigits[index - 1] = '';
                setDigits(newDigits);
                inputsRef.current[index - 1]?.focus();
            }
        }
    }

    function handlePaste(e) {
        e.preventDefault();
        const pasted = e.clipboardData.getData('text/plain').replace(/[^\d]/g, '').slice(0, 6);
        if (!pasted) return;
        const newDigits = [...digits];
        for (let i = 0; i < 6; i++) {
            newDigits[i] = i < pasted.length ? pasted[i] : '';
        }
        updateDigits(newDigits);
        const focusIndex = Math.min(pasted.length, 5);
        inputsRef.current[focusIndex]?.focus();
    }

    function handleSubmit() {
        const code = digits.join('');
        if (code.length === 6) {
            setLoadingSpinner(true);
            setParentCode(code);
        }
    }

    const inputClass = "w-12 h-14 text-xl text-center bg-white border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-transparent transition-shadow";

    return (
        <>
        <div className="flex gap-2 justify-center">
            {digits.map((digit, index) => (
                <input
                    key={index}
                    ref={el => inputsRef.current[index] = el}
                    type="text"
                    className={inputClass}
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onPaste={handlePaste}
                    inputMode="numeric"
                    autoComplete="off"
                />
            ))}
        </div>

        <button
            type="button"
            disabled={loadingSpinner}
            onClick={handleSubmit}
            className="mt-6 w-full flex items-center justify-center rounded-2xl py-4 text-base font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-60"
            style={{ backgroundColor: primaryColor }}
        >
            {loadingSpinner ? (
                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : (
                'Verify'
            )}
        </button>
        </>
    );
}
